export class UserAssignmentRequest {
    ItemID: string;
    StartDate: Date;
    EndDate: Date;
    ShouldSendNotifications: boolean;
    AssignedUsers: string[];
}